exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-lc[data-v-481ee0ab] {\n  width: 450px;\n}\n.w-lc-small[data-v-481ee0ab] {\n  width: 260px;\n}\n", ""]);

// exports
